// Define a base configuration for content
const baseContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "setting",
    file: {},
    isUpdated: false,
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: true,
    isUpdated: false,
  },
};

// Define a base configuration for input content
const baseInputContent = {
  type: "input",
  inputType: "url",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "generalSetting",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: true,
    isUpdated: false,
  },
};

// Factory function to create a setting entry
const createSettingEntry = (
  title: string,
  key: string,
  label: string = "",
  type: string = "image",
  inputType: string = "",
  isButton: boolean = true,
  translationRequired: boolean = true
) => ({
  title,
  content: {
    ...(type === "input" ? baseInputContent : baseContent),
    type,
    inputType,
    label,
    data: {
      ...baseContent.data,
      key,
    },
    translation: {
      ...(type === "input" ? baseInputContent.translation : baseContent.translation),
      flag: translationRequired,
    },
  },
  isRequired: false,
  readonly: false,
  isButton,
});

// Array of settings entries
const settingsEntries = [
  { title: "Login", key: "login" },
  { title: "Language", key: "language" },
  { title: "Faq", key: "faq" },
  { title: "Faq Url", key: "faqUrl", type: "input", inputType: "url", label: "Enter Faq Url", isButton: false, translationRequired: false },
  { title: "About Us", key: "aboutUs", label: "Please Enter About Us Url", translationRequired: false },
  { title: "About Us Url", key: "aboutUsUrl", type: "input", inputType: "url", label: "Enter About Us Url", isButton: false, translationRequired: false },
  { title: "Terms and Conditions", key: "termsAndConditions"},
  { title: "Terms and Conditions Url", key: "termsAndConditionsUrl", type: "input", inputType: "url", label: "Enter Terms and Conditions Url", isButton: false, translationRequired: false },
  { title: "Privacy", key: "privacy" },
  { title: "Notifications", key: "notificationIcon" },
  { title: "Access", key: "accessIcon" },
  { title: "Follow Us", key: "followUsIcon" },
];

// Map the settings entries to create the settings array
const settings = settingsEntries.map(({ title, key, label, type, inputType, isButton, translationRequired }) => 
  createSettingEntry(title, key, label, type, inputType, isButton, translationRequired)
);

export { settings };
